import React from 'react';

function BankTransfer(props) {
	const operator = props.operator || {};
	const centropuertoData = sessionStorage.getItem("centropuertoOperatorData");
	const parsedData = JSON.parse(centropuertoData);
  
	// Determine the bank account number and RUT destination account
	const isSpecificOperator = ['traveltur', 'pullmansanandres', 'cormarbus', 'andimar'].includes(operator.operator_name);
	const bankAccountNumber = parsedData.bank_info.acct_no;
	const rutDestAcc = isSpecificOperator
	  ? 'El saldo será acreditado a la billetera del titular de la cuenta bancaria.'
	  : props.t('PROFILE.RUT_DEST_ACC');
  
	return (
	  <div className="bank-transfer font11">
		<div className="step">
		  <div className="text">{props.t('PROFILE.TRANSFER_RECHARGE_AMOUNT')}</div>
		</div>
		<div className="details">
		  <div className="flex-row">
			<div className="label">{props.t('PROFILE.RECIPIENT')}:</div>
			<div className="value">
			  {parsedData.bank_info.name}
			</div>
		  </div>
		  <div className="flex-row">
			<div className="label">RUT:</div>
			<div className="value">{parsedData.bank_info.rut}</div>
		  </div>
		  <div className="flex-row">
			<div className="label">{props.t('PROFILE.BANK')}:</div>
			<div className="value">{parsedData.bank_info.bank}</div>
		  </div>
		  <div className="flex-row">
			<div className="label">{props.t('PROFILE.BANK_ACCOUNT')}:</div>
			<div className="value">{bankAccountNumber}</div>
		  </div>
		  <div className="flex-row">
			<div className="label">{props.t('PROFILE.EMAIL_ID')}:</div>
			<div className="value">{parsedData.bank_info.email}</div>
		  </div>
		</div>
		<div className="step">
		  <div className="text">
			{rutDestAcc}
		  </div>
		</div>
	  </div>
	);
  }
  
export default BankTransfer;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayRecharge/components/BankTransfer.js